export default __webpack_public_path__ + "static/media/Fletchergothicflf-VGqB.997efe36.ttf";